
const wwConstants = {
    GoomeRegExp : {
        phoneNumber:/^1[3|4|5|7|8][0-9]{9}$/,
        number:/^[0-9]*$/,
        licenseNumber:/^[\u4e00-\u9fa5]{1}[A-Z]{1}[A-Z_0-9]{5}$/
    },
    checkGoomeRegExp : {
        isPhoneNumber:function (str) {
            return wwConstants.GoomeRegExp.phoneNumber.test(str.toString());
        },
        isNumber: function (str) {
            return wwConstants.GoomeRegExp.number.test(str.toString());
        },
        isLicenseNumber:function (str) {
            return wwConstants.GoomeRegExp.licenseNumber.test(str.toString());
        }
    }
}
export default wwConstants